module.exports = __webpack_public_path__ + "img/google_sheets.45dd8dda.svg";